import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';
import { getLocation } from '@jira/ssr__browser-globals/src/getLocation.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const logEmauForJira = (subproduct: string, url: any, urlParams: any) => {
	const body = JSON.stringify({
		eventData: { url, subproduct, urlParams },
	});

	const endpointUrl = '/rest/internal/2/log/unsafe/emau';
	const fetchOptions = {
		...getDefaultOptions(endpointUrl),
		method: 'POST',
		body,
	};

	return fetch(endpointUrl, fetchOptions);
};

export const logEmau = ({ product, subproduct }: { product: string; subproduct: string }): void => {
	if (product === 'jira') {
		const location = getLocation();
		if (location) {
			logEmauForJira(subproduct, location.pathname, location.search);
		}
	}
};
